export default {
    'invoiceCarrier.title': '發票載具',
    'invoiceCarrier.error.format.one': '發票載具條碼格式錯誤。ex: 沒有填寫 / 或是字串長度錯誤。',
    'invoiceCarrier.error.format.two': '請輸入 / 開頭之載具條碼 (例： /A123456)',
    'invoiceCarrier.save': '儲存',
    'invoiceCarrier.setting_complete': '載具條碼設定完成',
} as Record<string, string>;
